export const ASSETS = {
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_afb6b7f1-813b-4f93-87a4-196d8dcdd6e7/artifacts/dd6275684347d2e9_Rose-Gold%20Goddess%20University%20Medallion.png",
  welcome: "https://customer-assets-lqy194kg.emergentagent.net/job_afb6b7f1-813b-4f93-87a4-196d8dcdd6e7/artifacts/3c7e29ddb16a0d7d_Feminine_Energy_Assessment_Welcome.png",
  results: "https://customer-assets-lqy194kg.emergentagent.net/job_afb6b7f1-813b-4f93-87a4-196d8dcdd6e7/artifacts/de4b686d8fe387b3_Feminine_Energy_Assessment_Results.png",
};
